var moduleSingleWorkshop = function() {
  var $ = jQuery;
  var _this;

  var module = {
    init: function() {
      _this = this;
      this.modifyDOM();
      this.addEvents();
    },

    modifyDOM: function() {
      $('.flexslider').flexslider({
        animation: 'slide',
        slideshow: false,
        animationSpeed: 250,
        multipleKeyboard: false,
        start: function() {
          $('.slides').show();
        }
      });
    },

    addEvents: function() {
      $('.widget--slideshow__expand').on('click', this.eventHandlers.initFullscreenGallery);
      $('.lager-modal--gallery .lager-modal__close').on('click', this.eventHandlers.removeFullscreenGallery);
    },

    eventHandlers: {
      initFullscreenGallery: function() {
        $('.lager-modal--gallery .lager-modal__container').flexslider({
          animation: 'slide',
          animationSpeed: 250,
          multipleKeyboard: true
        });
        $('.lager-modal--gallery').fadeIn(200);
      },

      removeFullscreenGallery: function() {
        $('.lager-modal--gallery .lager-modal__container').flexslider('destroy');
        $('.lager-modal--gallery').fadeOut(200);
      }
    },

    helpers: {
    }
  };

  module.init();
};
